import { useQuery } from '@tanstack/react-query'

import { messagingMethodsServices } from '../messagingMethodsServices'
import { MessagingMethodsParams } from '../messagingMethodsTypes'

import { QUERY_KEYS } from '@/constants/queryKeys'

export const useFetchMessagingMethods = (params: MessagingMethodsParams) =>
  useQuery({
    queryKey: [QUERY_KEYS.CATALOGS_MESSAGING_METHODS, params],
    queryFn: () => messagingMethodsServices.fetchMessagingMethods(params),
    staleTime: 5 * 60 * 1000,
  })
